var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3 splash-msg fade show"},[_c('h2',{staticClass:"text-success"},[_vm._v(_vm._s(_vm.title || 'Success!'))]),_c('p',{staticClass:"text-success pt-2"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }